module.exports = __webpack_public_path__ + "static/write2-057c283b830fb465cf9ed922d6de5a36.png";